import { useState } from "react"
import { router } from "@inertiajs/react"
import { StepShell } from "../components/StepShell"
import { DynamicList, KpiFieldRow } from "../components/DynamicList"
import { GuideMeCta } from "@/components/planning/client-only/GuideMeCta"
import { parseNamedTargetBullets } from "@/lib/guide-output"

function defaultRows(saved) {
  if (saved && saved.length > 0) return saved
  return Array.from({ length: 3 }, () => ({ name: "", target: "" }))
}

export function Kpis({ data }) {
  const [rows, setRows] = useState(() => defaultRows(data.annualPlan.annualKpis))
  const [processing, setProcessing] = useState(false)

  const submit = () => {
    setProcessing(true)
    router.patch(
      "/app/plan/intake",
      { step: "kpis", annual_kpis: rows, advance: "1" },
      { preserveScroll: true, onFinish: () => setProcessing(false) },
    )
  }

  // The guide chat returns bullets formatted "Name: Target" per the
  // system prompt in IntakeGuideService. Parse each into {name, target}
  // and drop into the KPI table. Anything that doesn't parse cleanly
  // is skipped silently rather than poisoning the form.
  const insertGuidedKpis = (bullets) => {
    const parsed = parseNamedTargetBullets(bullets).slice(0, 5)
    if (parsed.length === 0) return
    while (parsed.length < 3) parsed.push({ name: "", target: "" })
    setRows(parsed)
  }

  return (
    <StepShell
      title="Annual Business Dashboard"
      subtitle="3–5 Key Performance Indicators. The numbers you'll watch weekly to know the business is healthy."
      onNext={submit}
      processing={processing}
    >
      <GuideMeCta
        section="kpis"
        onInsert={insertGuidedKpis}
        title="Not sure which KPIs to pick?"
        subtitle="Talk it through with an AI coach — it knows your goals and one-year plan, and will help you land on 3–5 leading indicators that actually move the needle."
      />
      <DynamicList
        items={rows}
        onChange={setRows}
        min={3}
        max={5}
        newItem={() => ({ name: "", target: "" })}
        addLabel="Add another KPI"
        render={(item, update) => (
          <KpiFieldRow
            item={item}
            update={update}
            namePlaceholder="KPI name (e.g., Monthly Recurring Revenue)"
            targetPlaceholder="Target (e.g., $50k)"
          />
        )}
      />
    </StepShell>
  )
}
